// TODO(visgl-burn-in): remove this whole legacy `@react-google-maps/api` marker
// (keep RestaurantMarkerNew) once CONSUMER_ENABLE_GOOGLE_MAPS_API_UPDATE is fully
// rolled out.
import * as React from 'react';
import { InfoBox, Marker } from '@react-google-maps/api';

import { ConsumerPurchaseSummary } from 'generated/graphql';
import { core } from '@tock/coretypes';
import { mapPinIcon } from 'utils/mapsUtils';
import BaseComponent from '@tock/shared/components/BaseComponent';
import PopUp from 'components/profile/culinary-travel-log/PopUp';

// Width and height of the info box. Should be the same as .TravelLogMap-infoBoxContainer
// width and height.
const INFOBOX_WIDTH_PX = 231;
const INFOBOX_SINGLE_RESERVATION_TOTAL_HEIGHT_PX = 139;
const INFOBOX_MULTI_RESERVATION_TOTAL_HEIGHT_PX = 245;

// Height of the map pin when selected, plus a bit of extra offset so that the
// bubble doesn't touch the pin.
const INFOBOX_PIN_HEIGHT_PLUS_GAP_SIZE = 37;

interface Props {
  id: string;
  location: google.maps.LatLngLiteral;
  business: core.IBusinessPublic;
  purchases: ConsumerPurchaseSummary[];
  isOpen: boolean;

  onOpen(id: string): void;
  onClose(id: string): void;
}

export default class RestaurantMarker extends BaseComponent<Props> {
  handleMarkerClicked() {
    const { id, isOpen, onOpen, onClose } = this.props;
    if (isOpen) {
      onClose(id);
    } else {
      onOpen(id);
    }
  }

  onKeyPress(event: React.KeyboardEvent) {
    if (event.key === 'Enter') {
      this.handleMarkerClicked();
    }
  }

  onFocus(event: React.FocusEvent) {
    const { id, onOpen } = this.props;
    onOpen(id);
  }

  onBlur(event: React.FocusEvent) {
    const { id, onClose } = this.props;
    onClose(id);
  }

  render() {
    const { id, location, business, purchases, isOpen } = this.props;
    let pixelOffset: google.maps.Size;
    let containerClass: string | undefined;
    if (purchases.length === 1) {
      const popupBoxTopLeftCornerOffsetX = -INFOBOX_WIDTH_PX / 2;
      const popupBoxTopLeftCornerOffsetY =
        -INFOBOX_SINGLE_RESERVATION_TOTAL_HEIGHT_PX - INFOBOX_PIN_HEIGHT_PLUS_GAP_SIZE;
      pixelOffset = new google.maps.Size(
        popupBoxTopLeftCornerOffsetX,
        popupBoxTopLeftCornerOffsetY
      );
      containerClass = 'TravelLogMap-singleReservationInfoBoxContainer';
    } else {
      const popupBoxTopLeftCornerOffsetX = -INFOBOX_WIDTH_PX / 2;
      const popupBoxTopLeftCornerOffsetY =
        -INFOBOX_MULTI_RESERVATION_TOTAL_HEIGHT_PX - INFOBOX_PIN_HEIGHT_PLUS_GAP_SIZE;
      pixelOffset = new google.maps.Size(
        popupBoxTopLeftCornerOffsetX,
        popupBoxTopLeftCornerOffsetY,
        'px',
        'px'
      );
      containerClass = 'TravelLogMap-multipleReservationInfoBoxContainer';
    }
    return (
      <>
        <div
          onKeyPress={this.onKeyPress}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          tabIndex={0}
          role="button"
          aria-label={business.name || undefined}
          aria-expanded={isOpen}
        >
          <Marker
            position={location}
            key={id}
            onClick={this.handleMarkerClicked}
            icon={mapPinIcon(isOpen ? 35 : undefined)}
            options={{ optimized: false }}
          />
        </div>
        {isOpen && (
          <InfoBox
            position={location}
            options={{
              closeBoxURL: '',
              pixelOffset,
              boxClass: containerClass,
            }}
          >
            <PopUp business={business} purchases={purchases} />
          </InfoBox>
        )}
      </>
    );
  }
}
